import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import React from "react";

export interface LogoProps {
  title?: string;
  src?: any;
  image?: boolean;
  imageStyle?: object;
  color:
    | "initial"
    | "inherit"
    | "primary"
    | "secondary"
    | "textPrimary"
    | "textSecondary"
    | "error";
  noWrap?: boolean;
  hideOnMobile: boolean;
}

export class Logo extends React.Component<LogoProps> {
  public render() {
    const { color, title, src, image, imageStyle, noWrap } = this.props;

    return (
      <Hidden smDown={this.props.hideOnMobile}>
        <Typography variant="h6" color={color} noWrap={noWrap}>
          <img alt="logo" style={imageStyle} hidden={!image} src={src} />
          {title}
        </Typography>
      </Hidden>
    );
  }
}
